import {
  AiOutlineIdcard,
  AiOutlineUser,
  AiOutlineUserAdd,
} from "react-icons/ai";
import { MdOutlineAttachMoney } from "react-icons/md";
import { RiLayout4Line } from "react-icons/ri";
import RopFormsStepper from "../../../main/components/RopFormStepper";

const steps = [
  {
    label: "Detalhes",
    icon: <AiOutlineIdcard />,
  },
  {
    label: "Plano",
    icon: <MdOutlineAttachMoney />,
  },
  {
    label: "Usuário",
    icon: <AiOutlineUser />,
  },
  {
    label: "Colaboradores",
    icon: <AiOutlineUserAdd />,
  },
  {
    label: "Layout Padrão",
    icon: <RiLayout4Line />,
  },
];

export default function ClientFormsStepper(props: { activeStep: number }) {
  return <RopFormsStepper activeStep={props.activeStep} steps={steps} />;
}
